var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3149 9.26899L14.0834 12.5005L17.3149 15.732L15.9273 17.1196L12.6958 13.8881L9.4643 17.1196L8.07671 15.732L11.3082 12.5005L8.07671 9.26899L9.4643 7.8814L12.6958 11.1129L15.9273 7.8814L17.3149 9.26899ZM24.4717 12.5005C24.4717 18.9939 19.1892 24.2764 12.6958 24.2764C6.20238 24.2764 0.919922 18.9939 0.919922 12.5005C0.919922 6.00707 6.20238 0.724609 12.6958 0.724609C19.1892 0.724609 24.4717 6.00707 24.4717 12.5005ZM22.509 12.5005C22.509 7.08947 18.1068 2.68726 12.6958 2.68726C7.28478 2.68726 2.88257 7.08947 2.88257 12.5005C2.88257 17.9115 7.28478 22.3137 12.6958 22.3137C18.1068 22.3137 22.509 17.9115 22.509 12.5005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.cd7728e50f7ab81e573b9ae8e110ee74.svg";
export { ForwardRef as ReactComponent };